<template lang="pug">
.color-picker-container
  .preset-section
    .preset-buttons
      .preset-color(
        v-for="color in presetColors"
        :key="color"
        :style="{ backgroundColor: color, border: color === selectedHex ? '2px solid #333' : '1px solid #ccc' }"
        @click="updateColor(color)"
      )

      button.toggle-picker(@click="showPicker = !showPicker")
        | {{ showPicker ? 'Hide Color Picker' : 'Pick another color' }}
  .colorwheel
    transition(name="fade")
      chrome-picker(
        v-show="showPicker"
        :value="colorData"
        @input="onInput"
        :disable-alpha="true"
      )
</template>

<script>
import { Chrome } from 'vue-color';

export default {
  name: 'ColorPickerWithPresets',
  components: {
    'chrome-picker': Chrome
  },
  props: {
    value: Object,
    defaultColor: Object,
    presetColors: {
      type: Array,
      default: () => [
        '#f44836', '#e91e63', '#9c27b0', '#673ab7',
        '#3f51b5', '#2196f3', '#03a9f4', '#00bcd4',
        '#009688', '#4caf50', '#8bc34a', '#cddc39',
        '#ffeb3b', '#ffc107', '#ff9800', '#ff5722',
        '#795548', '#607d8b', '#000000', '#ffffff'
      ]
    }
  },
  data() {
    return {
      colorData: this.value || { hex: '#00FF00' },
      showPicker: false
    };
  },
  computed: {
    selectedHex() {
      return this.colorData?.hex?.toLowerCase();
    }
  },
  watch: {
    defaultColor: {
      immediate: true,
      handler(newColor) {
        if (newColor?.hex) {
          this.colorData = newColor;
          this.$emit('input', newColor);
        }
      }
    }
  },
  methods: {
    onInput(newColor) {
      this.colorData = newColor;
      this.$emit('input', newColor);
    },
    updateColor(hex) {
      const newColor = { hex };
      this.colorData = newColor;
      this.$emit('input', newColor);
    }
  }
};
</script>

<style scoped>
.color-picker-container {
  /* display: flex;
  flex-direction: column;
  gap: 1rem; */

  display: grid;
  grid-template-columns: auto auto;
  padding: 5px;
  margin-top: -22px;
}

.preset-section .label {
  font-weight: bold;
  margin-bottom: 0.25rem;
}
.preset-buttons {
  grid-column: 1 / span 2;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-width: 180px;
}
.preset-color {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  cursor: pointer;
}

button.toggle-picker {
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 4px 8px;
  cursor: pointer;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>